<template>
  <div class="table-container pull-auto">
    <div class="avue-crud">
      <avue-crud-table :data="list" @search-reset="searchReset" :option="tableoption" :page="page" @size-change="sizeChange" @current-change="currentChange" @row-click="showRow" @search-change="searchChange">
            <template slot="search">
                <el-form-item label="企业状态">
                    <el-select v-model="form.state" placeholder="请选择" clearable>
                        <el-option  v-for="item in workerState" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
            </template>
            <template slot-scope="scope" slot="menuLeft">
              <el-button class="filter-item filter-item1" size="mini" @click="examine" type="primary" icon="el-icon-view"  :disabled = "derail">查看
            </el-button>
            <el-button class="filter-item filter-item1" size="mini" @click="handleStop" type="primary" icon="el-icon-circle-close-outline"  :disabled = "coldderail">冻结
            </el-button>
            <el-button class="filter-item filter-item1" size="mini" @click="handleStart" type="primary" icon="el-icon-circle-check-outline"  :disabled = "nocoldderail">解冻
            </el-button>
            <el-button class="filter-item filter-item1" size="mini" @click="companyzy" type="primary" icon="el-icon-circle-check-outline"  :disabled = "nocoldderail">员工
            </el-button>
            </template>
            <template slot-scope="scope" slot="id">
                <el-radio class="radio" v-model="radio"  :label="scope.row.id"></el-radio>
            </template>
        </avue-crud-table>
    </div>
        <!--企业详情-->
       <companyinfo ref="childcompany" @refresh="refresh"></companyinfo>
       <workercald ref="childcald" @refresh="refresh"></workercald>
    </div>
</template>

<script>
  import {fetchList,selectState} from "@/api/admin/business";
  //import {dictionary} from '@/api/admin/workerUser'
  import { objKeySort } from '@/util/ajaxsign'
  import {companytable} from '@/const/asset/user'
  import {dealElement} from '@/util/util'
  import companyinfo from './companyinfo.vue'
  import workercald from './workercald.vue'
  export default {
    name: 'table_user',
    components: {companyinfo,workercald},
    data() {
      return {
        permissions : [],
        // 搜索
        form: {
            condition: '',
            state:''
        },
        radio:'',
        list: [],
        derail : true,
        coldderail : true,
        nocoldderail : true,
        listLoading: true,
        dictionarylist : {},
        workerState : [{value:0,label:"未认证"},{value:1,label:"待审核"},{value:2,label:"已认证"},{value:3,label:"拒绝审核"},{value:4,label:"已冻结"}],
        totalStatus : true,
        page: {
          pageSizes: [10, 20, 50, 100],
          currentPage: 1,
          total: 0,
          pageSize: 10
        },
        tableoption : companytable,
      }
    },
    computed: {},
    created() {
      this.getList()
      this.dictionarydata()
      this.permissions = JSON.parse(window.sessionStorage.getItem("userInfo")).permissions;
      for(var i=0;i<this.permissions.length;i++){
          if(this.permissions[i] == 'sys_user_add'){
            this.sys_user_add = this.permissions[i]
          }
          if(this.permissions[i] == 'sys_user_edit'){
            this.sys_user_edit = this.permissions[i]
          }
          if(this.permissions[i] == 'sys_user_del'){
            this.sys_user_del = this.permissions[i]
          }
      }
    },
    methods: {
      refresh(){
        this.getList();
        this.radio = undefined;
        this.derail = true;
        this.coldderail = true;
        this.nocoldderail = true;
      },

      showRow(row){
        this.radio = row.id;
        this.derail =false;
        this.nocoldderail = false;
        this.coldderail = false;
      },

      getList() {
        this.listLoading = true
        this.form.pageNum=this.page.currentPage
        this.form.pageSize = this.page.pageSize
        fetchList(objKeySort(dealElement(this.form))).then(response => {
           this.list = response.data.data.rows
           this.page.total = response.data.data.total
           this.listLoading = false
        })
      },

      //员工页面
      companyzy(){
        sessionStorage.setItem('companyId',this.radio)
        this.$router.push({ path: '/companyWorker/index',params:{'companyId':this.radio}})
      },


      //搜索
      searchChange(searchForm) {
        this.form.condition = searchForm.condition;
        console.log(this.form);
        this.getList()
      },
      //清空搜索条件
      searchReset(){
        this.form.state = '';
      },
      //分页
      sizeChange(val) {
        this.page.pageSize = val
        this.getList()
      },
      currentChange(val) {
        this.page.currentPage = val
        this.getList()
      },

      handleStart(){
           selectState(objKeySort({companyId:this.radio,status:1,tips:'解冻成功'})).then(response =>{
            this.$message({
                title: '解冻成功',
                message: '解冻成功',
                type: 'success',
                duration: 2000
              })
              this.refresh()
        })
      },

      //查看
      examine() {
        this.$refs.childcompany.setsataus(this.radio);
      },
      //冻结
      handleStop() {
        this.$refs.childcald.setsataus(this.radio,"冻结原因");
      }
    }
  }
</script>
